<script>
import sidebar from './sidebar.vue'
export default {
  components: { sidebar },
   name:"p-main-container",
   data() {
      return {}
   },
   props:['layout'],
   methods: {},
   created: function(){}
}
</script>
<template>
<div style="flex-grow:1;">
   <notifications group="base" />
   <slot name="toolbar"></slot>
   <!-- <slot name="sidebar"></slot> -->
   <sidebar></sidebar>
   <div class="main-container">
      <div class="panel-container d-flex">
         <main class="main-content">
            <slot></slot>
         </main>
         <aside v-if="layout == 'col-2-right'" class="widget-content">
            <slot name="col-right"></slot>
         </aside>
      </div>
   </div>
</div>
</template>
<style lang="scss"></style>


// WEBPACK FOOTER //
// src/js/components/p-main-layout.vue